module.exports = __webpack_public_path__ + "img/cave_border.1757558a.png";